import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import './index.css';
import Button from '../../../../../components/button';
import { useDispatch } from 'react-redux';
import { setPathArray } from '../../../../../reducer/adminSlice';
import { useTranslation } from 'react-i18next';

export default function ProfileCard({ onClick, item, activeIndex, index, setActiveIndex, serviceValue, callRedirect }) {
    const { t } = useTranslation("mediumBooking");
    const dispatch = useDispatch();
     const navigate = useNavigate();
    useEffect(() => {
        console.log("item ", item)
    }, [])
    let pricing = ''
    if(item.subsession_id == 94){
         pricing = item.coaching_pricing !== null && item.coaching_pricing !== "null" && item.coaching_pricing !== "free" ? item.coaching_pricing : 'Free'
    }else{
         pricing = item.coaching_pricing !== null && item.coaching_pricing !== "null" && item.coaching_pricing !== "free" ? Object.values(JSON.parse(JSON.parse(item.coaching_pricing)))[0] : 'Free'
    }

    const onClickHandler = (index, item) => {
        setActiveIndex(parseInt(index))
        onClick(item)

    }
    const viewProfileHandler = (e, item) => {
        e.stopPropagation();
        localStorage.setItem('PATH', item.id)

    }
     const viewProfileHandlerCoach = (e, item) => {
        e.stopPropagation();
        localStorage.setItem('PATH', item.id)
        callRedirect(item.id);
        //navigate(`/coach-reviews/${item.id}?from=booking&serviceValue=${serviceValue}`);

    }
    return (
        <>
            <div onClick={() => onClickHandler(index, item)} className={`profilecard-wrapper pointer ${activeIndex === parseInt(index) ? 'profilecard-selected' : ''}`} >

                <div className='profile-photo'>
                    <div >
                        <img width="100%" height="100%" src={item.profile_image !== null
                            ? `${process.env.REACT_APP_IMAGE_URL}${item.profile_image}`
                            : "/images/user-dummy.png"}
                        />
                    </div>
                </div>
                <div>


                    <div className='font-size-15 '>
                       {item.session_type === 2 ? (
                        <>
                            <span className="d-inline-block font-size-15 profile-details-medium">
                            {item.screen_name.length > 17
                                ? item.screen_name.substring(0, 17).concat("...")
                                : item.screen_name}
                            </span>
                            <a
                            title={t("profileCard.viewProfile")}
                            className="review-btn view-profile-btn d-inline-flex align-items-center justify-content-center"
                            target="_blank"
                            onClick={(e) => viewProfileHandlerCoach(e, item)}
                            //href={`/coach-reviews/${item.id}?from=booking&serviceValue=${serviceValue}`}
                            >
                            {t("profileCard.coachReviews")}
                            </a>
                        </>
                        ) : (
                        <>
                            {item.screen_name.length > 24
                            ? item.screen_name.substring(0, 24).concat("...")
                            : item.screen_name}
                        </>
                        )}
                        <br />

                    </div>

                    <div className='mt-1'>
                        <span className='d-inline-block font-size-15 profile-details-medium'>{pricing === "Free" ? t("profileCard.free") : t("profileCard.price", { price: pricing })}</span>
                        <a
                            title={t("profileCard.viewProfile")}

                            className={'resend-btn view-profile-btn  d-inline-flex align-items-center justify-content-center'}
                            target='_blank'
                            onClick={(e) => viewProfileHandler(e, item)}
                            href={`/public-view/${item.id}?from=booking&serviceValue=${serviceValue}`}

                        >{t("profileCard.viewProfile")}</a>
                    </div>
                </div>


            </div>
        </>
    )
}
